// extracted by mini-css-extract-plugin
export default {"body":"Z8CEMOfL3p"};